import {useEffect, useState} from 'react';
import {
  addBookMarkDailyReminder,
  dailyReminder,
  deleteBookMarkDailyReminder,
} from '../services/dailyReminder';

const useDailyReminderHook = () => {
  const [dailyReminderData, setDailyReminderData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false); // Add loading state

  const apiData = async () => {
    try {
      setLoading(true); // Start loading when the API call begins
      const response: any = await dailyReminder();
      setDailyReminderData(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Stop loading after the API call finishes
    }
  };

  const dailyReminderBookMark = async (id: number, type: string) => {
    const payload = {
      almMappingId: id,
      almMappingType: type,
    };
    try {
      await addBookMarkDailyReminder(payload);
      apiData();
    } catch (error) {
      console.log("error", error);
    }
  };
  const dailyReminderUnBookMark = async (id: number) => {
    try {
      await deleteBookMarkDailyReminder(id);
      apiData();
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    apiData();
  }, []);
  return {
    dailyReminderData,
    dailyReminderBookMark,
    dailyReminderUnBookMark,
    loading, // Return loading state
  };
};

export default useDailyReminderHook;
